// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"808":"fbc0925b","857":"d695c0f1","884":"c1165da1"}[chunkId] + ".chunk.css";
};